import React from "react";
import Slider from "react-slick";

const Certification = ({ classicHeader, darkTheme }) => {
  const reviews = [
    {
      src: "images/certification/msdb.jpg",
      desc: "This certification can be a stepping stone towards more advanced certifications like Microsoft Certified: Azure Database Administrator Associate or Microsoft Certified: SQL Server 2016 Database Administration. It's a good way to validate your basic knowledge and skills in database administration, making you more appealing to employers who are looking for entry-level database administrators.",
    },
    {
      src: "images/certification/msweb.jpg",
      desc: "The MTA Web Development Fundamentals certification is suitable for individuals who are seeking entry-level jobs in web development or who are looking to advance to more technical roles. This certification can provide a good foundational understanding of web development concepts and practices. It can also be a good way to differentiate yourself in the job market, especially if you're just starting your career in web development.",
    },
    {
      src: "images/certification/Docker Bootcamp.png",
      desc: "Docker Bootcamp is a comprehensive training program designed to provide hands-on experience and knowledge about Docker, a popular containerization platform. The bootcamp covers essential concepts and practical techniques for working with Docker containers.",
    },
    {
      src: "images/certification/JavaScript Bootcamp.png",
      desc: "JavaScript Bootcamp is an intensive training program designed to equip participants with the essential skills and knowledge to become proficient JavaScript developers. The bootcamp covers the fundamentals of JavaScript programming language, along with modern web development techniques and best practices.",
    },
    {
      src: "images/certification/react Bootcamp.png",
      desc: "The React Bootcamp is an immersive training program designed to provide participants with comprehensive knowledge and practical skills in React, a popular JavaScript library for building user interfaces. This bootcamp is tailored for individuals who want to become proficient in React development and create modern, interactive web applications.",
    },
  ];

  var settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };

  return (
    <section
      id="certification"
      className={"section " + (darkTheme ? "bg-dark-1" : "")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            Certification
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {" "}
            Certification
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}

        <Slider {...settings}>
          {reviews.length > 0 &&
            reviews.map((value, index) => (
              <div className="item" key={index}>
                <div
                  className={
                    "rounded p-5 " + (darkTheme ? "bg-dark" : "bg-light")
                  }
                >
                  <div className="d-flex align-items-center mt-auto mb-4">
                    <img
                      className="img-fluid border d-inline-block"
                      src={value.src}
                      alt=""
                      style={{width: "800px", maxWidth: "100%" }}
                    />
                  </div>
                  <p
                    className={
                      "fw-500 mb-4 " + (darkTheme ? "text-white" : "text-dark")
                    }
                  >
                    “{value.desc}”
                  </p>
                </div>
              </div>
            ))}
        </Slider>
      </div>
    </section>
  );
};

export default Certification;
